
import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import styles from "@/styles/mobile/SuccessMessage.module.scss"
import { useTheme } from "@/app/contexts/ThemeContext"
import CustomLink from "../CustomLink"

const SuccessMessageMobile: React.FC = () => {
    const { theme } = useTheme()
    const router = useRouter()
    const [counter, setCounter] = useState(5)

    const darkMode = theme === "dark" ? "Dark" : ""

    useEffect(() => {
        if (counter > 0) {
            const timer = setTimeout(() => {
                setCounter(counter - 1)
            }, 1000)
            return () => clearTimeout(timer)
        } else {
            router.push("/")
        }
    }, [counter, router])

    return (
        <main className={styles.main}>
            <img src={`https://gabcomercio.azureedge.net/azul-agro/general/success${darkMode}.svg`} alt="" width={200} height={205} />
            <h1 className="h2-bold">Formulário enviado com sucesso</h1>
            <CustomLink href="/" className="btn-primary">Retornar a home</CustomLink>
            <span className="defesa">Aguarde uns instantes... ({counter})</span>
        </main>
    )
}

export default SuccessMessageMobile
